/**
 * Panel sign-in through Cloudflare Access.
 *
 * The panel host sits behind Access (Google SSO). A Pages Function on the same
 * origin (`functions/cf-access/token.js`) returns the Access JWT, and the API
 * verifies it and grants the same session a magic link would. Anywhere that
 * function does not exist (local dev, a host not behind Access) the fetch comes
 * back empty and the magic-link login shows as before.
 */

export const ACCESS_TOKEN_PATH = "/cf-access/token"
export const ACCESS_LOGOUT_PATH = "/cdn-cgi/access/logout"
const SIGNED_IN_VIA_ACCESS = "condri_signed_in_via_access"

export async function fetchAccessToken(): Promise<string | null> {
  try {
    const res = await fetch(ACCESS_TOKEN_PATH, {
      credentials: "same-origin",
      cache: "no-store",
    })
    if (!res.ok) return null
    if (!res.headers.get("content-type")?.includes("application/json")) return null
    const body: unknown = await res.json()
    const token = (body as { token?: unknown } | null)?.token
    return typeof token === "string" && token ? token : null
  } catch {
    return null
  }
}

/**
 * Remembered so that signing out also ends the Access session; otherwise the
 * next page load would sign the same person straight back in.
 */
export function rememberAccessSignIn(signedIn: boolean): void {
  try {
    if (signedIn) localStorage.setItem(SIGNED_IN_VIA_ACCESS, "1")
    else localStorage.removeItem(SIGNED_IN_VIA_ACCESS)
  } catch {
    // Storage unavailable: sign-out falls back to the panel's own login page.
  }
}

export function signedInViaAccess(): boolean {
  try {
    return localStorage.getItem(SIGNED_IN_VIA_ACCESS) === "1"
  } catch {
    return false
  }
}
